import prepareApiUrl from '@/lib/helpers/prepareApiUrl';

const tempStorageUrl = (process.env.REACT_APP_CDN_STORAGE ?? '')?.toString();

const CDN_URL = tempStorageUrl.endsWith('/')
	? tempStorageUrl.slice(0, -1)
	: tempStorageUrl;

console.log('CDN_URL', {
	CDN_URL,
	REACT_APP_CDN_STORAGE: process.env.REACT_APP_CDN_STORAGE,
});

const NODE_API_URL = prepareApiUrl(process.env.REACT_APP_API_URL);

const GO_API_URL = prepareApiUrl(process.env.REACT_APP_SV_GO_API_URL);

// TODO: remove this when sv-go-api is updated (/login endpoint to be with v1)
const BASE_GO_API_URL = process.env.REACT_APP_SV_GO_API_URL?.endsWith('/v1')
	? process.env.REACT_APP_SV_GO_API_URL?.slice(0, -3)
	: process.env.REACT_APP_SV_GO_API_URL;

const WHISPER_ACTIONS = [
	{
		value: 'transcribe',
		label: 'Transcribe',
		enabled: true,
		// required: ['audio-quality'],
		required: [],
		group: 'transcribe',
	},
	{
		value: 'translate',
		label: 'Translate',
		enabled: true,
		// required: ['transcribe', 'ner'],
		required: [],
		group: 'transcribe',
	},
	// #region TextAnalytics
	{
		value: 'ner',
		label: 'Entity recognition',
		enabled: true,
		required: ['transcribe'],
		group: 'text-analytics',
	},
	{
		value: 'toxicity',
		label: 'Toxicity',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'iab-categories',
		label: 'IAB categories',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'personality',
		label: 'Personality',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'brand-safety',
		label: 'Brand safety',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'leaning',
		label: 'Leaning',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'tonality',
		label: 'Tonality',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'keywords',
		label: 'Keywords',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'direction-focus',
		label: 'Direction focus',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	// {
	// 	value: 'section-index-creation',
	// 	label: 'Section index creation',
	// 	enabled: true,
	// 	group: 'text-analytics',
	// 	required: ['transcribe'],
	// },
	// {
	// 	value: 'section-summary',
	// 	label: 'Section summary',
	// 	enabled: true,
	// 	group: 'text-analytics',
	// 	required: ['transcribe'],
	// },
	// {
	// 	value: 'overall-summary',
	// 	label: 'Overall summary',
	// 	enabled: true,
	// 	group: 'text-analytics',
	// 	required: ['transcribe'],
	// },
	// {
	// 	value: 'key-topics',
	// 	label: 'Key topics',
	// 	enabled: true,
	// 	group: 'text-analytics',
	// 	required: ['transcribe'],
	// },
	// {
	// 	value: 'key-takeaways',
	// 	label: 'Key takeaways',
	// 	enabled: true,
	// 	group: 'text-analytics',
	// 	required: ['transcribe'],
	// },
	// {
	// 	value: 'gold-brand-label-sampling',
	// 	label: 'Gold brand-label sampling',
	// 	enabled: true,
	// 	group: 'text-analytics',
	// 	required: ['transcribe'],
	// },
	// LLM-based text analytics
	{
		value: 'llm-ner',
		label: 'LLM Entity Recognition',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'llm-sentiment',
		label: 'LLM Sentiment Analysis',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'llm-topics',
		label: 'LLM Topics',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'llm-hierarchical-topics',
		label: 'LLM Hierarchical Topics',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'llm-keywords',
		label: 'LLM Keywords',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'llm-highlights',
		label: 'LLM Highlights',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'llm-opinion',
		label: 'LLM Opinion and Stance Analysis',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'llm-facts',
		label: 'LLM Facts and Claims Extraction',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'llm-toxicity',
		label: 'LLM Toxicity Detection',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	{
		value: 'llm-brand-safety',
		label: 'LLM Brand Safety',
		enabled: true,
		group: 'text-analytics',
		required: ['transcribe'],
	},
	// #endregion

	// #region AUDIO
	{
		value: 'music-detect',
		label: 'Music detection',
		enabled: true,
		required: [],
		group: 'audio-analytics',
	},
	{
		value: 'audio-quality',
		label: 'Audio quality',
		enabled: true,
		required: [],
		group: 'audio-analytics',
	},
	// {
	// 	value: 'vocal-emotion',
	// 	label: 'Vocal emotion',
	// 	enabled: true, // false
	// 	required: [],
	// 	group: 'audio-analytics',
	// },
	// {
	// 	value: 'music-copyright',
	// 	label: 'Music copyright',
	// 	enabled: true, // false
	// 	required: [],
	// 	group: 'audio-analytics',
	// },
	// #endregion

	// #region VIDEO/IMAGE analytics
	// {
	// 	value: 'thumbnail-insights',
	// 	label: 'Thumbnail insights',
	// 	enabled: true, // false
	// 	group: 'video/image-analytics',
	// 	required: [],
	// },
	// {
	// 	value: 'scene-extraction',
	// 	label: 'Scene extraction',
	// 	enabled: true, // false
	// 	group: 'video/image-analytics',
	// 	required: [],
	// },
	// {
	// 	value: 'person-identification',
	// 	label: 'Person identification',
	// 	enabled: true, // false
	// 	group: 'video/image-analytics',
	// 	required: [],
	// },
	// {
	// 	value: 'facial-emotion',
	// 	label: 'Facial emotion',
	// 	enabled: true, // false
	// 	group: 'video/image-analytics',
	// 	required: [],
	// },
	// {
	// 	value: 'action-analysis',
	// 	label: 'Action analysis',
	// 	enabled: true, // false
	// 	group: 'video/image-analytics',
	// 	required: [],
	// },
	// {
	// 	value: 'text-isolation',
	// 	label: 'Text isolation',
	// 	enabled: true, // false
	// 	group: 'video/image-analytics',
	// 	required: [],
	// },
	{
		value: 'logo-detection',
		label: 'Logo detection',
		enabled: true, // false
		group: 'video/image-analytics',
		required: [],
	},
	{
		value: 'text-detection',
		label: 'Text detection',
		enabled: true, // false
		group: 'video/image-analytics',
		required: [],
	},
	// #endregion
];

enum INITIALIZATION_STATUSES_ENUM {
	processing = 'processing',
	ready = 'ready',
	generating = 'generating',
	timeout = 'timeout',
	cancelled = 'cancelled',
	failed = 'failed',
}

enum SUBSCRIPTIONS_TYPES_ENUM {
	copilot = 'copilot',
	vod = 'vod',
	report = 'report',
	datalake = 'datalake',
}

const VIDEO_INSIGHTS_ACTIONS = [
	'Brand mention sentence/time isolation',
	'Brand sentiment at time identified',
	'MetaData',
	'Video summary',
	'Topic analysis',
	'Entity extraction',
	'Video transcription',
	'Text overlay',
	'Brand logo detection',
];

const PLATFORMS = [
	// {
	//   text: 'Facebook',
	//   value: 'facebook',
	// },
	{
		text: 'Youtube',
		value: 'youtube',
	},
	{
		text: 'Instagram',
		value: 'instagram',
	},
	// {
	//   text: 'Pinterest',
	//   value: 'pinterest',
	// },
	// {
	//   text: 'Twitch',
	//   value: 'twitch',
	// },
	{
		text: 'TikTok',
		value: 'tiktok',
	},
	{
		text: 'Twitter/X',
		value: 'twitter',
	},
	{
		text: 'LinkedIn',
		value: 'linkedin',
	},
];

const EXTRA_REPORTS_IDS = [
	'a84b1a99-dff3-443c-b76f-8c653431f9ac',
	'5407e89d-a3bf-40d5-ac0e-46ce62a7fee3',
	'f8ed117f-07a7-4ef2-87f7-5c7c65e1ca91',
	'37d176c7-14cc-4afb-91ec-2faad0a26547',
	'edb78b72-ff2d-4574-a3e4-e107f45f5389',
];

const FILTERS_DATE_FORMAT = 'D MMM, YYYY';

const FILTERS_PLATFORMS = ['YouTube', 'Instagram', 'TikTok'];
const TIME_PERIODS = [
	{ label: 'Today', days: 0 },
	{ label: 'Last 7 days', days: 7 },
	{ label: '1 month', days: 30 },
	{ label: '3 months', days: 90 },
	{ label: 'All time', days: null },
];
const SENTIMENTS = ['Positive', 'Negative', 'Neutral'];
const REACH = ['Mega', 'Macro', 'Micro', 'Nano'];
const AND_OR_OPTIONS = ['and', 'or'];

export {
	WHISPER_ACTIONS,
	INITIALIZATION_STATUSES_ENUM,
	VIDEO_INSIGHTS_ACTIONS,
	CDN_URL,
	NODE_API_URL,
	GO_API_URL,
	BASE_GO_API_URL,
	SUBSCRIPTIONS_TYPES_ENUM,
	PLATFORMS,
	EXTRA_REPORTS_IDS,
	FILTERS_DATE_FORMAT,
	FILTERS_PLATFORMS,
	TIME_PERIODS,
	SENTIMENTS,
	REACH,
	AND_OR_OPTIONS,
};
